/* global Forms  */

window['users#change_password'] = function () {
  Forms.initPasswordChecker()
}
